import{e as n,m as e}from"./chunk-HBP5N4FR.js";var r,d=n(()=>{e();r=t=>new Date().setSeconds(new Date().getSeconds()+t)/1e3});export{r as a,d as b};
//# sourceMappingURL=chunk-VTMJ7INI.js.map
